import {
  useContext,
} from "react";
import {DrupalNode} from "next-drupal";
import {DrupalProductNode} from "@/types/hygiena-types";
import {ProductHero} from "@/components/organisms/hero/product-hero";
import {ModalContext} from "@/context/modal-context";

import dynamic from "next/dynamic";
const ContentProduct = dynamic(() => import("./content/content--product").then((mod) => mod.ContentProduct));

/**
 * The full display for products.
 *
 * @param node
 *   The product node.
 * @param additionalContent
 *   Additional content.
 * @param props
 *   Additional properties.
 * @constructor
 */
export function NodeProduct({node, additionalContent, ...props}
  : {
  node: DrupalProductNode,
  additionalContent?: {
    relatedNews?: DrupalNode[]
  },
}) {
  const {setOpenModal, setOpenSmallModal, setOpenModalContent, setOpenSmallModalContent} = useContext(ModalContext);

  const productCategory = node?.field_product_category ?? null;
  const productClass = node?.field_product_class ?? null;

  return (
    <>
      {/* Main product displayed in the hero. */}
      <ProductHero taxonomy_term={productCategory ?? productClass} node={node}
                   openSmallModal={setOpenSmallModal} openSmallModalContent={setOpenSmallModalContent}
                   openModal={setOpenModal} openModalContent={setOpenModalContent} />
      {/* Everything beneath the hero is loaded in via a dynamic component */}
      <ContentProduct node={node} additionalContent={additionalContent} {...props}/>
    </>
  );
}
